
























import CImg from '~/components/shared/configurable/image/CImg.vue'
import { defineComponent, ref } from '@nuxtjs/composition-api'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineComponent({
  components: {
    CImg,
    PiraeusLoanForm: () =>
      import(
        '~/components/plot/classifieds/view/piraeus-loan/PiraeusLoanForm.vue'
      )
  },
  setup() {
    const isLoanFormVisible = ref(false)

    return { isLoanFormVisible }
  },
  i18n: defineComponentTranslations({
    mortgage_loan: {
      en: 'Get it with a mortgage loan',
      el: 'Απόκτησέ το με στεγαστικό δάνειο'
    },
    from_piraeus: {
      en: 'from Piraeus Bank',
      el: 'από την Τράπεζα Πειραιώς'
    }
  })
})
